import type { PlayerDataSnapshot } from '@/lib/api';
import type { CloudAllData } from '@/types/cloud-data';

export function workspaceSavePayload(snapshot: PlayerDataSnapshot, cloud: CloudAllData): Record<string, string> {
  if (snapshot.source !== 'cloudflare' || snapshot.saveVersion == null || snapshot.saveVersion < 1) throw Error('A current backend cloud save is required.');
  const original = JSON.parse(snapshot.Data.EC2_CLOUD_ALL_DATA.Value) as CloudAllData;
  if (cloud.userData.questId !== original.userData.questId && (!Number.isInteger(cloud.userData.questId) || cloud.userData.questId < 0 || cloud.userData.questId > 164)) throw Error('Story quest must be an integer from 0 to 164.');
  if (cloud.userData.lastCheckpoint !== original.userData.lastCheckpoint && (typeof cloud.userData.lastCheckpoint !== 'string' || cloud.userData.lastCheckpoint.length > 256)) throw Error('Checkpoint scene names must be at most 256 characters.');
  // Preserve every cloud/auxiliary/purchase key, including fields unknown to the UI.
  return { ...Object.fromEntries(Object.entries(snapshot.Data).map(([key, entry]) => [key, entry.Value])), EC2_CLOUD_ALL_DATA: JSON.stringify(cloud), FORCE: '1' };
}
export function sameCloudValue(a: string | undefined, b: string | undefined): boolean {
  if (a === b) return true;
  try { return JSON.stringify(JSON.parse(a!)) === JSON.stringify(JSON.parse(b!)); } catch { return false; }
}
export interface PreviewEdit { sourceValue: string; value: string }
export function readPreviewEdit(id: string): PreviewEdit | null {
  try {
    const value = JSON.parse(localStorage.getItem(`ec2-design-edits:${id}`) ?? 'null');
    return value && typeof value.sourceValue === 'string' && typeof value.value === 'string' ? value : null;
  } catch { return null; }
}
